import { Dispatch, SetStateAction, useState } from 'react';
import { ChevronDown, ChevronUp, Search } from 'react-feather';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Input } from 'reactstrap';
import { Filter, FindCourse } from '../../../../../../constants';
import CheckboxLists from './CheckboxLists';
import { FindCourseCardProps, StudentCourse } from '../../../../../../types/Courses';
import { useTranslation } from 'react-i18next';

const FindCourseCard = (props: FindCourseCardProps) => {
  const { t } = useTranslation();
  const [isFilter, setIsFilter] = useState(true);

  const { filters, setFilters, durationFilterSelectors } = props;
  const categoriesFilterSelectors =
    'categoriesFilterSelectors' in props ? props.categoriesFilterSelectors : undefined;
  return (
    <Col xl="12">
      <Card>
        <CardHeader>
          <h5 className="mb-0">
            <Button
              type="button"
              color="transparent"
              className="btn-link d-flex align-items-center gap-2 justify-content-between btn btn-transparent"
              onClick={() => setIsFilter(!isFilter)}
            >
              {props.title} {isFilter ? <ChevronDown /> : <ChevronUp />}
            </Button>
          </h5>
        </CardHeader>
        <Collapse isOpen={isFilter}>
          <CardBody className="filter-cards-view animate-chk">
            <div className="job-filter">
              <div className="faq-form">
                <Input
                  type="text"
                  placeholder={t('global.search')}
                  value={filters?.search}
                  onChange={(e) =>
                    setFilters((prev: any) => {
                      return {
                        ...prev,
                        search: e.target.value,
                      };
                    })
                  }
                />
                <Search className="search-icon" />
              </div>
            </div>
            <CheckboxLists
              categoriesFilterSelectors={
                categoriesFilterSelectors?.categories?.filterSelectors?.length
                  ? categoriesFilterSelectors
                  : null
              }
              durationFilterSelectors={durationFilterSelectors}
              setFilters={setFilters}
            />
            <Button color="primary" className="text-center">
              {t('filters.filterBtn')}
            </Button>
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};
export default FindCourseCard;
